import dayjs from 'dayjs';
import { AppAlert } from '@components/antd';
import { useAppBanner } from './hooks/use-app-banner';
import { ResumeSubscriptionModal } from '@modules/settings/subscription/components/modal-resume-subscription';
import { Trans } from 'react-i18next';

export const NonRenewingBanner = () => {
  const { resumeController, workspaceSubscription } = useAppBanner();
  return (
    <>
      <AppAlert
        showIcon
        type="warning"
        message={
          <>
            <Trans
              i18nKey="your_subscription_is_scheduled_to_cancel_after_your_current_billing_cycle_end_on_day_resume"
              components={[<a key="resume-link" className="cursor-pointer" onClick={resumeController.handleOpen}></a>]}
              values={{ day: dayjs(workspaceSubscription?.currentTermEnd).format('MMM D, YYYY') }}
            />
          </>
        }
      />
      <ResumeSubscriptionModal
        loading={resumeController.loading}
        open={resumeController.open}
        handleClose={resumeController.handleClose}
        onSubmit={resumeController.onSubmit}
      />
    </>
  );
};
